import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Span } from '@ubisend/pulse-components';
import { TemplatingTextInput } from '@ubisend/pulse-templating';
const ListenForDtmfOnVoiceCallContent = ({ content, onChange }) => {
  const handleMaximumAllowedChange = value => {
    onChange({
      maximumAllowed: String(value ?? '')
    });
  };

  return (
    <Flex center fat xSpace>
      <Span>allowing</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Maximum allowed DTMF digits"
          placeholder="Maximum allowed"
          value={String(content.maximumAllowed ?? '')}
          onChange={handleMaximumAllowedChange}
        />
      </Flex>
      <Span>DTMF inputs</Span>
    </Flex>
  );
};

ListenForDtmfOnVoiceCallContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    maximumAllowed: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired
  }).isRequired
};

export default ListenForDtmfOnVoiceCallContent;